import React, { ReactElement } from 'react';
import { Divider, Flex, Typography } from 'antd';

interface FormItemsProps {
  children: ReactElement | ReactElement[];
  actions?: ReactElement | null;
}

const FormItems: React.FC<FormItemsProps> = ({ children, actions }) => {
  if (!children) return null;

  const childrens = Array.isArray(children) ? children : [children];

  const items = childrens.map((Child) => {
    return (
      <Flex vertical key={Child?.props?.label}>
        <div>
          <div>
            {actions ? (
              <Flex align="center" justify="space-between">
                {actions}
              </Flex>
            ) : (
              <Typography.Text className="form-item-label" strong>
                {Child?.props?.label}
              </Typography.Text>
            )}
          </div>
          <Divider />
        </div>
        <div className="form-items" key={Child?.props?.label}>
          {Child}
        </div>
      </Flex>
    );
  });

  return (
    <>
      {items.map((FormItemElement, index) => (
        // eslint-disable-next-line
        <React.Fragment key={index}>{FormItemElement}</React.Fragment>
      ))}
    </>
  );
};

export default FormItems;
